import localStorage from 'shared/utils/localStorage';

const LEGIT_USER_LOCALE = process.env.REACT_APP_LOCALE_KEY;

function createUserLocaleLocalStorage() {
  if (!LEGIT_USER_LOCALE) {
    throw new Error();
  }

  return {
    isStored: () => !!localStorage.get(LEGIT_USER_LOCALE),
    get: () => localStorage.get(LEGIT_USER_LOCALE),
    set: (userLocale: string) => localStorage.set(LEGIT_USER_LOCALE, userLocale),
    delete: () => localStorage.delete(LEGIT_USER_LOCALE)
  };
}

const userLocaleLocalStorage = createUserLocaleLocalStorage();

export default userLocaleLocalStorage;
